import React, { useState } from 'react';

import { Eye, Settings } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
import {
  Button,
  CardCell,
  CardRow,
  StyledTable,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from '@randstad-lean-mobile-factory/react-components-core';
import moment from 'moment';

import { useFetchCronJobConfigs } from '../../../Hooks/CronJobs/useFetchCronJobConfigs';
import { CronJobConfig } from '../../../Services/API';
import { CronJobDetailsModalComponent } from '../../Modals/CronJobDetailsModal';
import { CronJobConfigModal } from '../../Modals/CronJobDetailsModal/CronJobConfigModal';
import TopBar from '../TopBar';

import styles from './CronJobsSection.module.scss';

const CronJobsSection = () => {
  const { data } = useFetchCronJobConfigs();
  const [selectedCronJob, setSelectedCronJob] = useState<CronJobConfig>();
  const [open, setOpen] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);

  return (
    <>
      <TopBar />
      <div className={styles.content}>
        <StyledTable size="small">
          <TableHeader>
            <TableRow>
              <TableHead>tâche</TableHead>
              <TableHead>activation</TableHead>
              <TableHead>dernière exécution</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {data?.map(cronJob => {
              return (
                <CardRow key={cronJob.cronJobId}>
                  <CardCell>{cronJob.cronJobId}</CardCell>
                  <CardCell>{cronJob.enabled ? 'activé' : 'désactivé'}</CardCell>
                  <CardCell>
                    {cronJob.lastExecution
                      ? moment(cronJob.lastExecution).format('LLLL')
                      : 'jamais exécuté'}
                  </CardCell>
                  <CardCell>
                    <Button
                      variant="ghost"
                      onClick={() => {
                        setSelectedCronJob(cronJob);
                        setOpenEdit(true);
                      }}
                    >
                      <Settings variant="line" />
                    </Button>
                    <Button
                      variant="ghost"
                      onClick={() => {
                        setSelectedCronJob(cronJob);
                        setOpen(true);
                      }}
                    >
                      <Eye variant="line" />
                    </Button>
                  </CardCell>
                </CardRow>
              );
            })}
          </TableBody>
        </StyledTable>

        {selectedCronJob && (
          <>
            <CronJobDetailsModalComponent
              cronJob={selectedCronJob}
              open={open}
              onClose={() => {
                setOpen(false);
                setSelectedCronJob(undefined);
              }}
            />
            <CronJobConfigModal
              cronJobConfig={selectedCronJob}
              open={openEdit}
              onClose={() => {
                setOpenEdit(false);
                setSelectedCronJob(undefined);
              }}
            />
          </>
        )}
      </div>
    </>
  );
};

export default CronJobsSection;
